export default __webpack_public_path__ + "static/media/screenBlock14.1aa90d5f.jpg";